import { createI18n } from 'vue-i18n';

import eng from './en-en.json'
import benl from './be-nl.json'
import dede from './de-de.json'
import befr from './be-fr.json'

let messages = {}
messages.enEn = eng;
messages.beNl = benl;
messages.deDe = dede;
messages.beFr = befr;

let locales = {} 
locales['en-en'] = 'enEn';
locales['de-de'] = 'deDe';
locales['be-fr'] = 'beFr';
locales['be-nl'] = 'beNl';
locales['pl-pl'] = 'plPl';
locales['es-es'] = 'esEs';
locales['it-it'] = 'itIt';
locales['br-pt'] = 'brPt';
locales['tr-tr'] = 'trTr';
locales['hu-hu'] = 'huHu';
locales['nl-nl'] = 'nlNl';

var locale = localStorage.getItem('locale')

const i18n = createI18n({
	locale: locales[locale], 
	fallbackLocale: 'enEn',
	messages
})

export default i18n;